// pages/Favorites.js
import React from 'react';

function FavoritesPage() {
  return (
    <div className="pb-20 p-4 max-w-6xl mx-auto">
      <h2 className="text-2xl font-bold mb-4 mt-4">Your Favorite Brands</h2>
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mx-auto text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
        <p className="mt-4 text-gray-600">You haven't added any brands to your favorites yet.</p>
        <p className="mt-2 text-gray-500">Browse brands and click the heart icon to save them here.</p>
      </div>
    </div>
  );
}

export default FavoritesPage;